import { utcDateTime } from './utc-date-time';

export function isSameDate(first: string, second?: string | null) {
  if (!first || !second) return false;
  const firstDate = utcDateTime(first);
  const secondDate = utcDateTime(second);

  return firstDate.hasSame(secondDate, 'day');
}
